import React, { useState } from 'react';

const QuickLinks = () => {
  const [isOpen, setIsOpen] = useState(false);

  const links = [
    { name: 'About Us', href: '/about' },
    { name: 'Privacy Policy', href: '#' },
    { name: 'Cancellation Policy', href: '#' },
    { name: 'Terms & Conditions', href: '#' },
    { name: 'Disclaimer', href: '#' },
    { name: 'Become a Partner', href: '#' },
    { name: 'Blogs', href: '/blogs-page' },
  ];

  return (
    <div className="border-b border-gray-800 md:border-none">
      <button
        className="flex justify-between items-center w-full text-white font-bold mb-4 md:mb-4 md:cursor-default"
        onClick={() => setIsOpen(!isOpen)}
      >
        <h3>Quick Links</h3>
        <svg
          className={`w-5 h-5 md:hidden transform ${isOpen ? 'rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      <ul className={`space-y-2 ${isOpen ? 'block' : 'hidden'} md:block`}>
        {links.map((link, index) => (
          <li key={index}>
            {link.href === '#'  ? (
              <span
                className="text-gray-400 cursor-not-allowed block"
                title="Coming Soon"
              >
                {link.name}
              </span>
            ) : (
              <a
                href={link.href}
                className="text-gray-300 hover:text-white transition-colors duration-200"
              >
                {link.name}
              </a>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default QuickLinks;
